import React from "react"
import styled from "styled-components"

export const NoteContainer = styled.div`
  padding: 30px 0;
  line-height: 1.5;
`
export const StyledNote = styled.div`
  // padding: 30px 0;
  ul {
    // margin-bottom: 20px;
    list-style: square;
    padding-left: 20px;
    li {
      font-size: 0.9em;
    }
  }
`

export const StyledFixedNote = styled.ul`
  list-style: square;
  padding-left: 20px;
  li {
    font-size: 0.9em;
  }
`

export default function Note({ html }) {
  return (
    <NoteContainer>
      <StyledNote dangerouslySetInnerHTML={{ __html: html }} />
      <StyledFixedNote>
        <li>
          食品&nbsp;100g&nbsp;当たり、トランス脂肪酸&nbsp;0.3g&nbsp;未満、コレステロール&nbsp;5mg&nbsp;未満である場合、「0」としています。
        </li>
      </StyledFixedNote>
    </NoteContainer>
  )
}
